import Navigation from "../components/Navigation";
import HeroSection from "../components/HeroSection";
import MissionVisionSection from "../components/MissionVisionSection";
import FoodPantryCTA from "../components/FoodPantryCTA";
import StatisticsSection from "../components/StatisticsSection";
import HomeNewsSection from "../components/HomeNewsSection";
import ContactSection from "../components/ContactSection";
import BottomDonateSection from "../components/BottomDonateSection";

// Main Home Page
const HomePage = () => {
  return (
    <div data-testid="home-page" className="min-h-screen">
      <Navigation />
      <HeroSection />
      <MissionVisionSection />
      <FoodPantryCTA />
      <StatisticsSection />
      <HomeNewsSection />
      <ContactSection />
      <BottomDonateSection />
    </div>
  );
};

export default HomePage;
